import type { HTMLAttributes } from 'react';

import { EXCEPTIONS_MESSAGE } from '../../configs/error/error.config';

import type { ITextFieldProps } from './textField.type';

export const mapInputModeFromType = (
  type: ITextFieldProps<string>['type'],
): HTMLAttributes<unknown>['inputMode'] => {
  switch (type) {
    case 'text':
    case 'email':
    case 'search':
    case 'tel':
    case 'url':
      return type;

    case 'number':
      return 'numeric';

    case 'password':
    case undefined:
      return 'text';

    default: {
      const x: never = type;

      throw new Error(EXCEPTIONS_MESSAGE.notHandledKey(x));
    }
  }
};
